import { Paper, Toolbar } from '@mui/material';
import { Trans } from 'react-i18next';

const DemoBar = (): JSX.Element => {

  return (
    <div style={{ display: "inline" }} >
      <Paper elevation={2} sx={{ backgroundColor: '#FFF055', color: 'black' }}>
        <Toolbar>
          <b><Trans>DemoBanner</Trans></b>
        </Toolbar>
      </Paper>
    </div >
  );
};

export default DemoBar;
